import React from "react";
import "./details.css";
import Location from '../../../../assets/images/pin.png'
import mail from '../../../../assets/images/email-con.png'

const Details = () => {
  return (
    <>
      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="col-md-4 offset-md-2">
            <div className="detail-card">
              <div className="content-card">
                <img src={Location} alt="location" />
                <p className="loc-title">Location</p>
                <p className="loc-detils">
                The Long Lodge, 265-269, Kingston Road, United Kingdom, Wimbledon, SW193NW
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="detail-card">
            <div className="content-card">
                <img src={mail} alt="location" />
                <p className="loc-title">Email</p>
                <p className="loc-detils">
                Venkatesh.ramamoorthy@saasphire.co.uk
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Details;
